import uuidv4 from 'uuid/v4';
import store from '@store';
import { addChecks, setSeat, updateCartAfterNote } from '@reducers/orders';
import { setErrorPopUp } from '@reducers/notification';
import { updateChecksAfterResponse } from '@reducers/storeChecks';
import { addInProcessItemsToCart } from '../MenuOrderHandler';
import CustomEventEmitter from '@utility/customEventEmitter';
import { getObjectValue } from '@utility/utills';
import { safeJsonParse } from '@utility/helperFunction';
import { returnSentItems } from './CartItems/CartHelper';

const handleRepeateDataSentCart = ({ CheckHeader, data }) =>
  getObjectValue(() => CheckHeader?.orders[0]?.items, []).reduce((a, v) => {
    if (v.itemType !== 'D') {
      const orderJson = safeJsonParse(v.orderJson, {});
      const modifierJson = safeJsonParse(orderJson.modifierJson, {});
      if (orderJson?.refill) {
        const refillItem = data.find(i => i.id === v.checkItemId);
        modifierJson.menuItemId = refillItem?.menuItemId;
        modifierJson.menuItemName = refillItem?.menuItemName;
        a.push({ ...v, ...orderJson, ...modifierJson });
      } else {
        a.push({ ...v, ...orderJson, ...modifierJson });
      }
    }
    return a;
  }, []);

export const handleRepeatData = ({ data, isRefill = false }) => {
  const { orders, oauth } = store.getState();
  const isPendingList = orders.isPendingList;
  const cart = orders.cart;
  const isSentCart = !isPendingList;
  const deviceInfo = oauth.deviceInformation;
  const userInfo = oauth.loggedInUserData;
  const menuItemsHashTable = orders.menuItemsHashTable;
  const check = orders.seats;

  const cb = (Cart, CheckHeader) => {
    let ItemsCart = Cart;

    if (isSentCart) {
      ItemsCart = handleRepeateDataSentCart({ CheckHeader, data });
    }

    const requiredCartItems = [];
    data.forEach(item => {
      const seatIds = item?.seats?.map(el => el.seatId);
      const refillMenuItemId = isRefill
        ? menuItemsHashTable[item.menuItemId]?.refillMenuItemId
        : null;
      const refillMenuItem = refillMenuItemId
        ? menuItemsHashTable[refillMenuItemId]
        : null;

      if (item.hasLinkedMenuItem || item.combo) {
        const uniqueId = ItemsCart.find(e => e.checkItemId === item.id)
          ?.uniqueIdForLinkedItem;
        const changedUniqueId = uuidv4();
        ItemsCart.forEach(v => {
          if (
            v.itemType !== 'D' &&
            v.uniqueIdForLinkedItem &&
            (v.uniqueIdForLinkedItem === item.uniqueIdForLinkedItem ||
              v.uniqueIdForLinkedItem === uniqueId)
          ) {
            const randomNumber = Math.trunc(Math.random() * 10000);
            const newInternalId = +`${new Date().getTime()}${randomNumber}`;
            const modifierJson = safeJsonParse(v.modifierJson, {});
            if (safeJsonParse(v?.orderJson, {})?.refill) {
              modifierJson.menuItemId = item?.menuItemId;
              modifierJson.menuItemName = item?.menuItemName;
            }
            if (refillMenuItemId) {
              modifierJson.menuItemId = refillMenuItemId;
              modifierJson.menuItemName = refillMenuItem?.name;
            }
            requiredCartItems.push({
              ...v,
              internalId: newInternalId,
              uniqueIdForLinkedItem: changedUniqueId,
              seatIds: (seatIds?.length > 0 && seatIds) || v?.seatIds,
              modifierJson: JSON.stringify({
                ...modifierJson,
                internalId: newInternalId,
                uniqueIdForLinkedItem: changedUniqueId,
                seatIds: (seatIds?.length > 0 && seatIds) || v?.seatIds,
              }),
              modifiers: !item.isLinked ? [] : v.modifiers,
              refill: isRefill,
            });
          }
        }, []);
      } else {
        const cartItem = ItemsCart.find(
          e =>
            e.itemType !== 'D' &&
            (e.internalId === item.internalId || e.checkItemId === item.id)
        );
        const randomNumber = Math.trunc(Math.random() * 10000);
        const newInternalId = +`${new Date().getTime()}${randomNumber}`;
        const modifierJson = safeJsonParse(cartItem?.modifierJson, {});
        if (
          cartItem?.orderJson &&
          safeJsonParse(cartItem?.orderJson, {})?.refill
        ) {
          modifierJson.menuItemId = item?.menuItemId;
          modifierJson.menuItemName = item?.menuItemName;
        }
        if (refillMenuItemId) {
          modifierJson.menuItemId = refillMenuItemId;
          modifierJson.menuItemName = refillMenuItem?.name;
        }
        requiredCartItems.push({
          ...cartItem,
          internalId: newInternalId,
          seatIds: (seatIds?.length > 0 && seatIds) || cartItem.seatIds,
          modifierJson: JSON.stringify({
            ...modifierJson,
            internalId: newInternalId,
            seatIds: (seatIds?.length > 0 && seatIds) || modifierJson.seatIds,
          }),
          refill: isRefill,
        });
      }
    });

    const dataToSend = {
      storeId: deviceInfo?.storeId,
      deviceId: deviceInfo?.deviceId,
      employeeId: userInfo?.id,
      checkHeaderId: check?.id,
      employeeCard: userInfo?.employeeCard,
      items: requiredCartItems,
      orderJson: JSON.stringify(requiredCartItems),
      latitude: '0',
      longitude: '0',
      geoLocation: '0',
    };

    store
      .dispatch(addChecks(dataToSend, 'add'))
      .then(result => {
        store.dispatch(updateChecksAfterResponse(result));
        store.dispatch(setSeat(result));
        const cartItems = getObjectValue(() => result?.orders[0]?.items, [])
          .filter(e => e.pending)
          .map(it => {
            const modifierJson = safeJsonParse(
              safeJsonParse(it.orderJson, {})?.modifierJson,
              {}
            );
            const refillItem = safeJsonParse(it.orderJson, {});
            return {
              ...modifierJson,
              modifierJson: JSON.stringify(modifierJson),
              id: it.id,
              pending: true,
              refill: refillItem?.refill,
            };
          });
        CustomEventEmitter.dispatchEvent('getCartItems', cartItems);
        store.dispatch(updateCartAfterNote(cartItems));
      })
      .catch(err => {
        store.dispatch(setErrorPopUp({ res: err.message }));
      });
  };

  addInProcessItemsToCart(cb, cart);
};

// Resolves the checkedItems map to actual item objects, then triggers repeat.
// Used by CartButtons for multi-select repeat.
export const repeatSelectedItems = checkedItems => {
  const { orders } = store.getState();
  const isPendingList = orders.isPendingList;
  const cart = orders.cart;
  const check = orders.seats;
  const position = orders.position;

  let selectedItemObjects;
  if (isPendingList) {
    // Pending items use internalId as the checkbox key
    selectedItemObjects = cart.filter(item => checkedItems[item.internalId]);
  } else {
    // Sent items use id as the checkbox key; resolve via returnSentItems
    const sentItems = returnSentItems(check, position) ?? [];
    selectedItemObjects = sentItems.filter(item => checkedItems[item.id]);
  }

  if (!selectedItemObjects || selectedItemObjects.length === 0) return;

  handleRepeatData({ data: selectedItemObjects });
};
